"use strict";

import './highcharts.less';

PF.Charts = PF.Charts || {};

PF.Charts.Highcharts = class HighCharts extends PF.Widget
{

    static get options()
    {
        return {
            content_id: "highcharts-content",
            charts: 'chart',
            html: PF.Charts.Highcharts.templates,
            dom: {},
            chart: { type: 'line' },
            title: null,
            subtitle: {},
            xAxis: {},
            yAxis: {},
            tooltip: {},
            plotOptions: {},
            accessibility: {},
            series: [],
            navigation: {},
            legend: {},
            exporting: {
                chartOptions: { // specific options for the exported image
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    }
                },
                menuItemDefinitions: {
                },
                buttons: {
                    contextButton: {
                        menuItems: [
                            "viewFullscreen",
                            "printChart",
                            'separator',
                            'exportSvg',
                            "exportPng",
                            // 'separator',
                            // 'downloadPNG',
                            // "downloadJPEG",
                            // "downloadPDF",
                            'separator',
                            'downloadXLSX',
                            'exportCSV',
                            // 'annotations',
                            'viewData',
                        ]
                    }
                },
                libURL: "/highcharts/lib/",
                fallbackToExportServer: false
            },
        };
    }

    static get templates()
    {
        return {
            content: `
                <figure class="highcharts-figure" pf="highchartsFigure">
                    <div pf="highchartsContainer"></div>
                </figure>
				`,
        };
    }

    init()
    {
        this.state = 'init';
        this.dom.loads(this.html);
        this.dom.element.append(this.dom.content);
        this.load();
    }

    load()
    {
        this.id = 'highcharts-' + PF.H.randomString(5);
        this.dom.highchartsContainer.node.setAttribute('id', this.id);
        this.exporting.error = this.fallbackHandler;
        let option = {
            chart: this.chart,
            title: this.title,
            subtitle: this.subtitle,
            xAxis: this.xAxis,
            yAxis: this.yAxis,
            tooltip: this.tooltip,
            plotOptions: this.plotOptions,
            accessibility: this.accessibility,
            series: this.series,
            navigation: this.navigation,
            legend: this.legend,
            exporting: this.exporting,
        };

        this.pluginXLSX(Highcharts);
        this.pluginCustom(Highcharts);

        if (this.charts == 'chart')
        {
            this.creat = Highcharts.chart(this.dom.highchartsContainer.node, {
                ...option
            });
        }
        if (this.charts == 'stockChart')
        {
            this.creat = Highcharts.stockChart(this.dom.highchartsContainer.node, {
                ...option
            });
        }
        if (this.chart.panning == true)
        {
            this.dom.highchartsContainer.css('overflow', 'auto');
        }
    } // load

    // Highcharts plugin for adding better XLS and XLSX support through the third party zipcelx library. (standalone.js)
    pluginXLSX(H)
    {
        if (window.zipcelx && H.getOptions().exporting)
        {
            H.Chart.prototype.downloadXLSX = function ()
            {
                var div = document.createElement('div'),
                    name,
                    xlsxRows = [],
                    rows;
                div.style.display = 'none';
                document.body.appendChild(div);
                rows = this.getDataRows(true);
                xlsxRows = rows.slice(1).map(function (row)
                {
                    return row.map(function (column)
                    {
                        return {
                            type: typeof column === 'number' ? 'number' : 'string',
                            value: column
                        };
                    });
                });

                // Get the filename, copied from the Chart.fileDownload function
                if (this.options.exporting.filename)
                {
                    name = this.options.exporting.filename;
                } else if (this.title && this.title.textStr)
                {
                    name = this.title.textStr.replace(/ /g, '-').toLowerCase();
                } else
                {
                    name = 'chart';
                }

                window.zipcelx({
                    filename: name,
                    sheet: {
                        data: xlsxRows
                    }
                });
            };

            // Default lang string, overridable in i18n options
            H.getOptions().lang.downloadXLSX = 'Экспорт в XLSX';

            // Add the menu item handler
            H.getOptions().exporting.menuItemDefinitions.downloadXLSX = {
                textKey: 'downloadXLSX',
                onclick: function ()
                {
                    this.downloadXLSX();
                }
            };

            // Replace the menu item
            var menuItems = H.getOptions().exporting.buttons.contextButton.menuItems;
            menuItems[menuItems.indexOf('downloadXLS')] = 'downloadXLSX';
        }
    }

    fallbackHandler(options)
    {
        if (options.type !== 'image/svg+xml' && isEdgeBrowser ||
            options.type === 'application/pdf' && isMSBrowser)
        {
            console.log(options.type + ' fell back on purpose');
        } else
        {
            console.log(options);
            throw 'Should not have to fall back for this combination. ' +
            options.type;
        }
    }

    pluginCustom(H)
    {
        H.Chart.prototype.exportTest = function (type, exe)
        {
            let name = this.title.textStr;
            if (this.subtitle.textStr)
            {
                name = this.subtitle.textStr;
            }
            let source = '';
            if (exe == 'csv')
            {
                source = this.getCSV();
            } else
            {
                source = this.getSVG({
                    exporting: {
                        sourceHeight: this.chartHeight,
                        sourceWidth: this.chartWidth,
                    }
                });
            }

            var element = document.createElement('a');
            element.download = name + '.' + exe;
            element.style.display = 'none';
            element.className = 'external';
            if (exe == 'csv' || exe == 'svg')
            {
                if (exe == 'svg')
                {
                    element.href = `data:image/svg+xml;charset=utf-8,` + encodeURIComponent(source);
                } else
                {
                    // let url = "data:text/csv;charset=utf-8," + escape(this.getCSV());
                    // window.open(url, 'export.csv');
                    element.href = `data:text/plain;charset=utf-8,%EF%BB%BF` + encodeURIComponent(source);
                }
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            } else
            {
                var canvas = document.createElement('canvas');
                canvas.width = this.chartWidth;
                canvas.height = this.chartHeight;
                var ctx = canvas.getContext('2d');

                // var img = document.createElement('img');
                var img = new Image;
                img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(source)));
                img.onload = function ()
                {
                    ctx.drawImage(img, 0, 0);
                    // window.open(canvas.toDataURL(type));
                    element.href = canvas.toDataURL(type);
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                };
            }
        };

        H.getOptions().lang.exportCSV = 'Экспорт в CSV';
        H.getOptions().exporting.menuItemDefinitions.exportCSV = {
            textKey: 'exportCSV',
            onclick: function ()
            {
                this.exportTest('text/plain', 'csv');
            },
        };
        H.getOptions().lang.exportSvg = 'Экспорт в SVG';
        H.getOptions().exporting.menuItemDefinitions.exportSvg = {
            textKey: 'exportSvg',
            onclick: function ()
            {
                this.exportTest('image/svg+xml', 'svg');
            },
        };

        H.getOptions().lang.exportPng = 'Экспорт в PNG';
        H.getOptions().exporting.menuItemDefinitions.exportPng = {
            textKey: 'exportPng',
            onclick: function ()
            {
                this.exportTest('image/png', 'png');
            },
        };
    }
}